import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { DataService, HelperService, HTTPService } from 'app/services';
import { findIndex } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-canned-inspection-browse',
  templateUrl: './canned-inspection-browse.component.html',
  styleUrls: ['./canned-inspection-browse.component.scss'],
})
export class CannedInspectionBrowseComponent implements OnInit, OnDestroy {
  cannedInspections: any[] = [];
  visibleCannedInspection: any[] = [];
  selectedCategoryItemCount: any = {};
  orderTitle: string = '';
  query: string = '';
  isSelected: boolean = false;
  selectedId: string = '';
  isDVIRecommendedServicesEnabled: boolean = true;
  isOpenFromInspection: boolean = false;
  isAddCannedServicesFromInspection: boolean = false;
  selectedServices: any = [];
  motorVehicle: any = {};
  vehicle: any = {};
  dataListener: Subscription;
  currentLang: string = 'en';
  companyLocalization: boolean = false;

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.orderTitle = this.dialogConfig.data.orderTitle;
    this.currentLang = this.dialogConfig.data.currentLang;
    this.companyLocalization = this.dialogConfig.data.companyLocalization;

    this.isAddCannedServicesFromInspection = this.dialogConfig.data.isAddCannedServicesFromInspection;
    this.isOpenFromInspection = this.dialogConfig.data.isOpenFromInspection;
    this.isDVIRecommendedServicesEnabled =
      this.isOpenFromInspection && this.isDVIRecommendedServicesEnabled;

    if (this.isAddCannedServicesFromInspection) {
      this.vehicle = this.dialogConfig.data.vehicle || {};
      if (this.vehicle.apiResponse && this.vehicle.apiResponse.BaseVehicleID) {
        this.motorVehicle = this.vehicle.apiResponse;
      }
      this.dataListener = this.dataService.getData().subscribe(({ data }) => {


        if (data.type === 'sidebar' && data.tab === 'close' && data.data) {
          const { vehicle, type } = data.data;

          if (type === 'ro-vehicle' && vehicle && vehicle._id) {
            if (this.vehicle && this.vehicle.vehicleId === vehicle._id) {
              if (vehicle.apiResponse) {
                this.motorVehicle = vehicle.apiResponse;
              }
            }
          }
        }
      });
    }

    this.getCannedInspectionList();
  }

  ngOnDestroy() {
    if (this.dataListener) {
      this.dataListener.unsubscribe();
    }
  }

  searchCannedInspection(value: string) {
    const query = value.toLowerCase();
    this.visibleCannedInspection = this.cannedInspections.filter(({ title }) =>
      title.toLowerCase().includes(query)
    );
  }

  getCannedInspectionList() {
    let fetchCannedServices = false;
    if (this.isAddCannedServicesFromInspection) fetchCannedServices = true;
    this.httpService.getInspection(fetchCannedServices).then(
      (res: any) => {
        if (res && res.records) {
          if (this.isAddCannedServicesFromInspection) {
            this.cannedInspections = res.records;
            this.visibleCannedInspection = this.helperService.deepCopy(this.cannedInspections);
            this.visibleCannedInspection.forEach(element => {
              if (element.associatedCannedServices?.length === 0) {
                element.associatedCannedServices.push({ text: 'No service is associated to this Inspection yet' });
              }
            })
          } else {
            res.records.forEach((inspection) => {
              const newInspection = { ...inspection, isAdded: false };
              if (inspection.titleFr || inspection.titleFR) {
                newInspection.titleFR = inspection.titleFr || inspection.titleFR;
              }
              this.cannedInspections.push(newInspection);
            });
            //isChecked
            this.visibleCannedInspection = [];

            this.cannedInspections.forEach((inspection) => {
              const categories = [];

              if (inspection.category && inspection.category.length) {
                inspection.category.forEach((cat: any) => {
                  if (cat.inspectionItems && cat.inspectionItems.length) {
                    // cat.inspectionItems = cat.inspectionItems.filter(
                    //   ({ isChecked }) => isChecked
                    // );

                    cat.inspectionItems.forEach((item) => {
                      item.isDefaultChecked = item.isChecked;
                      item.isChecked = false;
                    });
                  }

                  if (cat.inspectionItems && cat.inspectionItems.length) {
                    categories.push(cat);
                  }
                });

                if (categories.length) {
                  inspection.category = categories;
                  this.visibleCannedInspection.push(inspection);
                }
              }
            });
          }
        }
      },
      (err) => {
        console.error(err);
        this.helperService.showToaster('error', err);
      }
    );
  }

  renderPartHourCount(data) {
    let hours = 0;
    let parts = 0;
    let laborCost = 0;
    let partCost = 0;
    if (data.items && data.items.length) {
      data.items.forEach((item) => {
        if (item.type === 'labor') {
          hours += 1;
          laborCost += item.subTotal;
        }
        if (item.type === 'part') {
          parts += 1;
          partCost += item.subTotal;
        }
      });
    }
    return {
      count: `
      ${hours ? `${hours} hours` : ''}
      ${parts ? `${parts} parts` : ''}
      `,
      partCost,
      laborCost,
      isAdded: false,
    };
  }

  addToEstmate(
    inspection: any,
    isAdded: boolean,
    index: number,
    event,
    toggleAccordian
  ) {
    event.stopPropagation();

    // Disabling the single selection
    //By adding beta flag we are disabling the single selection
    if (!this.isDVIRecommendedServicesEnabled) {
      if (this.isSelected && !isAdded) {
        this.helperService.showToaster(
          'error',
          'You can only select one canned inspection'
        );
        return;
      }
    }

    for (let i = 0; i < this.cannedInspections.length; i++) {
      if (this.cannedInspections[i]._id === inspection._id) {
        this.cannedInspections[i].isAdded = !isAdded;
        this.isSelected = !isAdded;
        this.selectedId = inspection._id;

        this.cannedInspections[i].category.forEach((category: any) => {
          let activeItemCount = 0;

          if (category.inspectionItems) {
            if (isAdded) {
              category.inspectionItems.forEach((item: any) => {
                item.isChecked = false;
              });
            } else {
              category.inspectionItems.forEach((item: any) => {
                item.isChecked = item.isDefaultChecked;
              });
            }

            activeItemCount = category.inspectionItems.filter(
              ({ isChecked }) => isChecked
            ).length;
          }

          category.itemCount = isAdded ? 0 : activeItemCount;
        });
        break;
      }
    }

    toggleAccordian(!isAdded);
  }

  renderCategoriesAndItems(inspection: any) {
    let categoryCount = 0;
    let itemCount = 0;

    inspection.category.forEach((category: any) => {
      categoryCount += 1;
      if (category.inspectionItems && category.inspectionItems.length) {
        itemCount += category.inspectionItems.length;
      }
    });

    return `${categoryCount} ${categoryCount > 1 ? 'categories' : 'category'
      }, ${itemCount} ${itemCount > 1 ? 'items' : 'item'}`;
  }

  handleCategorySelect(
    event: any,
    type: string,
    inspection: any,
    categoryIndex: number,
    toggleAccordian: any
  ) {
    event.stopPropagation();

    for (let i = 0; i < this.cannedInspections.length; i++) {
      if (this.cannedInspections[i]._id === inspection._id) {
        if (!this.isDVIRecommendedServicesEnabled) {
          if (this.isSelected && this.selectedId !== inspection._id) {
            this.helperService.showToaster(
              'error',
              'You can only select one canned inspection'
            );
            return;
          }
        }

        if (!type) {
          this.cannedInspections[i].category[
            categoryIndex
          ].inspectionItems.forEach((item) => {
            item.isChecked = true;
          });
          this.cannedInspections[i].category[
            categoryIndex
          ].itemCount = this.cannedInspections[i].category[
            categoryIndex
          ].inspectionItems.length;
          this.cannedInspections[i].isAdded = true;
          this.isSelected = this.cannedInspections[i].isAdded;
          this.selectedId = this.cannedInspections[i]._id;
          break;
        } else {
          let selectedCategoryCount = 0;
          const ins = this.cannedInspections[i];
          ins.category[categoryIndex].inspectionItems.forEach((item) => {
            item.isChecked = false;
          });

          ins.category[categoryIndex].itemCount = 0;
          ins.category.forEach((cat) => {
            selectedCategoryCount =
              selectedCategoryCount + (cat.itemCount || 0);
          });
          this.cannedInspections[i].isAdded = selectedCategoryCount > 0;
          this.isSelected = this.cannedInspections[i].isAdded;
          this.selectedId = this.cannedInspections[i].isAdded
            ? this.cannedInspections[i]._id
            : '';
          break;
        }
      }
    }

    toggleAccordian(type === 'select');
  }

  handleSelectChange(isChecked, inspectionIndex, categoryIndex, inspection) {
    for (let i = 0; i < this.cannedInspections.length; i++) {
      if (this.cannedInspections[i]._id === inspection._id) {
        if (!this.isDVIRecommendedServicesEnabled) {
          if (this.isSelected && this.selectedId !== inspection._id) {
            this.helperService.showToaster(
              'error',
              'You can only select one canned inspection'
            );
            return;
          }
        }
        const ins = this.cannedInspections[i];
        if (isChecked) {
          ins.isAdded = true;
          ins.category[categoryIndex].itemCount =
            1 + (ins.category[categoryIndex].itemCount || 0);
          this.isSelected = true;
          this.selectedId = this.cannedInspections[i]._id;
        } else {
          let selectedCategoryCount = 0;
          ins.category[categoryIndex].itemCount =
            (ins.category[categoryIndex].itemCount || 0) - 1;
          ins.category.forEach((cat) => {
            selectedCategoryCount =
              selectedCategoryCount + (cat.itemCount || 0);
          });
          this.cannedInspections[i].isAdded = selectedCategoryCount > 0;
          this.isSelected = this.cannedInspections[i].isAdded;
          this.selectedId = this.cannedInspections[i]._id;
        }
        break;
      }
    }
  }

  getAddedProperties() {
    const inspections = [];

    this.cannedInspections.forEach((inspection, index) => {
      if (inspection.isAdded) {
        const categories = [];
        inspection.category.forEach((category) => {
          if (category.itemCount) {
            const items = category.inspectionItems.filter(
              ({ isChecked }) => isChecked
            );
            categories.push({ ...category, inspectionItems: items });
          }
        });
        if (categories.length) {
          inspections.push({ ...inspection, category: [...categories] });
        }
      }
    });
    return inspections;
  }

  renderSelectItemText(data) {
    const { selectedCount, totalCount } = data;
    return `${selectedCount}/${totalCount} items selected`;
  }

  close(isSubmitted: boolean) {
    if (this.isAddCannedServicesFromInspection) {
      this.dynamicDialogRef.close({
        isSubmitted,
        data: this.selectedServices,
        motorServices: {},
        // motorServicesNewGen: this.getMotorSelectedServiceNewGen(),
        motorServicesNewGen: {},
        serviceInspections: this.getSelectedInspections(),
        motorVehicle: this.motorVehicle,
        deferredServices: {},
      });
    } else {
      if (!this.isDVIRecommendedServicesEnabled) {

        const inspections = this.getAddedProperties();

        if (isSubmitted) {
          if (inspections && inspections.length) {
            this.dynamicDialogRef.close({
              isSubmitted,
              data: inspections[0],
            });
          } else {
            this.helperService.showToaster(
              'error',
              'Inspection must contain atleast one item'
            );
          }
        } else {
          this.dynamicDialogRef.close({
            isSubmitted,
            data: null,
          });
        }
      } else {
        const inspections = this.getAddedProperties();
        if (isSubmitted) {
          if (inspections && inspections.length) {
            this.dynamicDialogRef.close({
              isSubmitted,
              data: inspections,
            });
          }
        } else {
          this.dynamicDialogRef.close({
            isSubmitted,
            data: null,
          });
        }
      }
    }
  }

  getSelectedInspections() {
    const services = Object.values(this.selectedServices);
    const serviceInspections = [];

    services.forEach((service: any) => {
      serviceInspections.push({
        id: service._id,
        _id: service._id,
        isInspectionChecked: true,
        items: service.items,
      });
    });

    return serviceInspections;
  }

  getInspectionServicesCount(inspection) {
    const services = inspection.associatedCannedServices.filter(element => element._id);
    return services.length;
  }

  toggleInspection(event, inspection, toggleAccordian) {
    event.stopPropagation();
    inspection.isSelected = !inspection.isSelected;
    toggleAccordian(inspection.isSelected);
  }

  handleCannedServicesSelect(event, service: any) {
    console.log(event);
    service.isSelected = !service.isSelected;
    if (service.isSelected && findIndex(this.selectedServices, { _id: service._id }) === -1) {
      this.selectedServices.push(service);
    } else {
      this.selectedServices.splice(findIndex(this.selectedServices, { _id: service._id }), 1);
    }
  }
}
